import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY } from "../../../api/queryKeys";
import { ProgramItemsInterface } from "./useSaveOnboarding";

async function saveProgram(data: ProgramItemsInterface) {
  return api
    .put(QUERY_ADMIN_DASHBOARD_PROGRAMS_KEY, {
      ...data,
    })
    .then((res) => res.data);
}

export default function useSaveProgram() {
  return useMutation(saveProgram, {
    onError: (error: AxiosError) => {
      const message = (error.response?.data as any).error;
      if (error && message) {
        toast.error(message);
      } else {
        toast.error("We were unable to save the program. Please try again.");
      }
    },
    onSuccess: (data) => {
      toast.success("Program saved successfully");
    },
  });
}
